var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"content"},[_c('iframe',{staticStyle:{"border":"none","width":"100%","min-height":"600px","height":"100vh","position":"relative"},attrs:{"src":"//b2bapp.helloholidays.ro/?"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }